export default "__VITE_PUBLIC_ASSET__fdc2ac9e__"